import ApiService from '@/services/core/api.service'

const TemplateService = {
  async get (query) {
    return ApiService.get(`admin/templates?${query}`)
  },

  async post (payload) {
    return ApiService.post('admin/templates', payload)
  },

  async put (payload) {
    return ApiService.put(`admin/templates/${payload.id}`, payload)
  }

}

export default TemplateService
